/**
 * 배너 오버레이 문구 폰트 — 배너가 실제로 렌더될 때만 Google Fonts 를 지연 로딩한다.
 * (관리자 미리보기와 동일 키/패밀리를 사용)
 */
interface BannerFont {
  key: string;
  family: string;
  href: string | null; // null = 번들 기본
}

const BANNER_FONTS: BannerFont[] = [
  {
    key: "gothic",
    family: "'Pretendard Variable','Noto Sans KR',sans-serif",
    href: null,
  },
  {
    key: "blackhan",
    family: "'Black Han Sans',sans-serif",
    href: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
  },
  {
    key: "jua",
    family: "'Jua',sans-serif",
    href: "https://fonts.googleapis.com/css2?family=Jua&display=swap",
  },
  {
    key: "dohyeon",
    family: "'Do Hyeon',sans-serif",
    href: "https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap",
  },
  {
    key: "gamja",
    family: "'Gamja Flower',cursive",
    href: "https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap",
  },
];

const byKey = (key?: string | null): BannerFont =>
  BANNER_FONTS.find(f => f.key === key) ?? BANNER_FONTS[0];

/** 폰트 키의 font-family 반환 + 필요 시 Google Fonts <link> 1회 주입(지연 로딩). */
export function ensureBannerFont(key?: string | null): string {
  const f = byKey(key);
  if (typeof document !== "undefined" && f.href) {
    const id = `bannerfont-${f.key}`;
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = f.href;
      document.head.appendChild(link);
    }
  }
  return f.family;
}
